export enum SocketEventEnum {
  APP_NOTIFICATION = "app_notification",
  UNSEEN_NOTIFICATIONS_COUNT = "unseen_notifications_count",
}
